












import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {}
})

export default class NotChromeAlert extends Vue {
    private isOpened: boolean = true;

    private closeAlert(): void
    {
        this.isOpened = false;
    }
}
